import React, { useEffect, useMemo, useRef, useState } from 'react';
import { __, sprintf } from '@wordpress/i18n';
import { isEmpty, isNil } from 'ramda';

// store
import { storeSet, useStoreValue } from '../../store';

// api
import TicketService from '../../service/ticket-service';

// components
import { Button } from 'primereact/button';
import { useNavigate, useParams } from 'react-router-dom';
import { Skeleton } from 'primereact/skeleton';
import TicketInfo from './components/TicketInfo';
import TicketComunications from './components/TicketComunications';
import { Toast } from 'primereact/toast';


const Ticket = () => {
    const isAsyncRequest = useStoreValue('isAsyncRequest');
    const getRole = useStoreValue('getRole');
    const {id} = useParams();
    const navigate = useNavigate();
    const [data, setData] = useState({});
    const toast = useRef(null);

    const goToAssistancePage = () => {
        navigate('/assistenza');
    };

    const getCallback = (resp) => {
        if (resp.status === 'SUCCESS') {
            setData(resp.data);
        }
        storeSet('unsetAsyncRequest');
    };

    const errGetCallback = (resp) => {
        storeSet('unsetAsyncRequest');
    };

    const handleCloseTicket = () => {
        storeSet('setAsyncRequest');
        TicketService.updateTicketStatus(data.id, closeCallback, errCloseCallback, [
            ['ticketStatus', 'CLOSE']
        ]);
    }

    const closeCallback = (resp) => {
        if (resp.status === 'SUCCESS') {
            if (toast.current) {
                toast.current.show({
                    severity: 'success',
                    summary: '',
                    detail: resp.message
                });
            }
            setData(prev => ({...prev, status: 'CLOSE'}));
        }
        storeSet('unsetAsyncRequest');
    };

    const errCloseCallback = (resp) => {
        storeSet('unsetAsyncRequest');
    };

    useEffect(() => {
        storeSet('setAsyncRequest');

        if (id && !isEmpty(id)) {
            TicketService.getTicketById(id, getCallback, errGetCallback);
        }
    }, [id]);

    return (
        <div className="appPage">
            <div className="appPage__pageHeader">
                <h1>{sprintf(__('Ticket: #%s', 'htr'), data.id)}</h1>
            </div>
            <Toast ref={toast}/>

            <div className="appPage__spacer"></div>

            <div className="appPageSection__row">
                <Button
                    type="button"
                    outlined
                    onClick={goToAssistancePage}
                    label={__('Indietro', 'htr')}
                    icon="pi pi-arrow-left" iconPos="left"/>
            </div>

            <div className="appPage__spacer"></div>

            {!isAsyncRequest && !isEmpty(data)
                ? <div className="appPage__content">
                    <TicketInfo data={data}/>

                    <div className="appPageSection">
                        <h2>{data.title}</h2>

                        <div dangerouslySetInnerHTML={{__html: data.description}}></div>
                    </div>

                    <div className="appPageSection">
                        <h2>{__('Comunicazioni', 'htr')}</h2>
                        <TicketComunications
                            ticketId={data.id}
                            status={data.status}/>
                    </div>

                    {getRole !== 'ROLE_CONFIDI'
                        ? <>
                            <div className="appPage__spacer"></div>

                            <div className="appPageSection__hr">
                                <span>{__('Azioni', 'htr')}</span>
                            </div>

                            <div className="appPageSection">
                                <div className="appPageSection__actions">
                                    <Button
                                        disabled={data.status === 'CLOSE' || isAsyncRequest}
                                        type="button"
                                        onClick={handleCloseTicket}
                                        severity="warning"
                                        icon="pi pi-times" iconPos="right"
                                        label={__('Chuidi il ticket', 'htr')}
                                    />
                                </div>
                            </div>
                        </> : null}

                </div>
                : <>
                    <Skeleton width="20%" height="1rem" className="mb-2"></Skeleton>
                    <Skeleton width="100%" height="2rem" className="mb-8"></Skeleton>
                    <Skeleton width="20%" height="1rem" className="mb-2"></Skeleton>
                    <Skeleton width="100%" height="4rem" className="mb-8"></Skeleton>
                    <Skeleton width="20%" height="1rem" className="mb-2"></Skeleton>
                    <Skeleton width="100%" height="2rem" className="mb-8"></Skeleton>
                    <Skeleton width="20%" height="1rem" className="mb-2"></Skeleton>
                    <Skeleton width="100%" height="4rem"></Skeleton>
                </>}
        </div>
    );
};

export default Ticket;